<template>
  <div id="googleMap" ref="googleMap"></div>
</template>

<style lang="scss" src="./google-map.scss"></style>
<script src="./google-map.js"></script>
